module.exports = __webpack_public_path__ + "img/logo-ofis-footer.f27f7ae3.svg";